import { render, staticRenderFns } from "./ConsentStatus.vue?vue&type=template&id=2f7d535e&"
import script from "./ConsentStatus.vue?vue&type=script&lang=js&"
export * from "./ConsentStatus.vue?vue&type=script&lang=js&"
import style0 from "./ConsentStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ConsentStatus.vue"
export default component.exports